import { jsx as _jsx } from "react/jsx-runtime";
const sizeClasses = {
    sm: 'size-4',
    md: 'size-6',
    lg: 'size-8',
};
export function Spinner({ size = 'md', className = '' }) {
    return (_jsx("span", { className: `inline-block rounded-full border-2 border-transparent border-t-accent ${sizeClasses[size]} ${className}`, style: { animation: 'sam-spin 0.6s linear infinite' }, role: "status", "aria-label": "Loading" }));
}
//# sourceMappingURL=Spinner.js.map